export default __webpack_public_path__ + "static/media/logo.35e48543.png";